export interface FieldConfig {
  collapsable?: boolean;
  label?: string;
  mediatypes?: string[];
  multiSelect?: boolean;
  name?: string;
  options?: { value: string; label: string }[];
  order?: number;
  type: "dates" | "dropdown" | "radio" | "text";
}
export interface AddCreativeMediatypeConfig {
  details: Record<string, FieldConfig>;
  generateCreatives: Function;
  getCustomAttributes: Function;
  renderDuplicateCreatives: Function;
  renderGeneratedCreatives: Function;
  saveNewCreatives: Function;
  updateDetails: Function;
}

export const LANGUAGES = {
  english: {
    abbrev: "E",
    label: "English",
  },
  spanish: {
    abbrev: "S",
    label: "Spanish",
  },
  french: {
    abbrev: "F",
    label: "French",
  },
};

export const customAttributesConfig: Record<string, FieldConfig> = {
  concept: {
    type: "dropdown",
    label: "Concept",
  },
  insightCategories: {
    type: "dropdown",
    label: "Insight Categories",
  },
};
